import React from 'react';
import PropTypes from 'prop-types';
import JobStatusView from './JobStatusView';
import JobStatusEdit from './JobStatusEdit';

const JobStatus = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    jobData,
    jobBackend,
  } = props;

  return (
    <>
      <JobStatusView
        jobData={jobData}
        jobBackend={jobBackend}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
      {
        isEditing &&
        <JobStatusEdit
          jobData={jobData}
          jobBackend={jobBackend}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      }
    </>
  );
};

JobStatus.propTypes = {
  jobData: PropTypes.object.isRequired,
  jobBackend: PropTypes.object.isRequired,
};

export default React.memo(JobStatus);
